function _toSmily(smily: string): string {
	let reply = smily;

	switch (smily) {
		case ':)':
		case ':-)':
			reply = '<div class="smiley happy"></div>';
			break;
		case ':D':
		case ':-D':
			reply = '<div class="smiley laughing"></div>';
			break;
		case ';)':
		case ';D':
		case ';-)':
		case ';-D':
			reply = '<div class="smiley wink"></div>';
			break;
		case ':P':
		case ':p':
		case ';P':
		case ';p':
		case ':-P':
		case ':-p':
		case ';-P':
		case ';-p':
			reply = '<div class="smiley tongue"></div>';
			break;
		case ':O':
		case ':o':
		case ';O':
		case ';o':
		case ':-O':
		case ':-o':
		case ';-O':
		case ';-o':
			reply = '<div class="smiley surprised"></div>';
			break;
		case ':*':
		case ';*':
		case ':-*':
		case ';-*':
			reply = '<div class="smiley kiss"></div>';
			break;
		case ':(':
		case ';(':
		case ':-(':
		case ';-(':
			reply = '<div class="smiley sad"></div>';
			break;
		case ':|':
		case ':-|':
			reply = '<div class="smiley neutral"></div>';
			break;
	}

	return reply;
}

export function replaceSmily(message: string): string {
	message = message.replace(/[:;]-?[)D(pP*|]/g, _toSmily);

	return message;
}
